import React, { useContext } from "react";
import { ResourceList, InlineStack, Text, Link, Badge } from "@shopify/polaris";

// import helpers
import baseHelper from "lib/helpers/base";

// import context
import { PrivateContext } from "lib/context/privateContext";

// import cms
import paymentListData from "app/userManagement/modules/generic/automaticPayout/feature/cms/paymentListData";

// import propTypes
import { listProp } from "app/userManagement/modules/generic/automaticPayout/feature/propsType";
import { useNavigate } from "react-router-dom";

function List(props) {
  const { cms } = useContext(PrivateContext);
  const navigate = useNavigate();
  const resourceData = paymentListData(cms);
  const { mainLink, links } = resourceData;
  const { item } = props;
  const { _id, dueDate, errorMessage, gateway, status, orderNumber, vendor, createdAt, orderId, vendorId } = item;
  let badgeColor = "success";
  switch (status.toLowerCase()) {
    case "pending":
      badgeColor = "new";
      break;
    case "failed":
    case "error":
      badgeColor = "warning";
      break;

    default:
      break;
  }
  return (
    <ResourceList.Item id={_id}>
      <InlineStack align="space-evenly">
        <InlineStack align="space-between" blockAlign="center">
          <Text variant="headingMd" as="h2">
            {`${cms("label.orderId")}: `}
            <Link onClick={() => navigate(`${mainLink.orderNumber}${orderId}`)}>{`#${orderNumber}`}</Link>
          </Text>
          <Text variant="headingMd" as="h2">{`(${baseHelper.ucFirst(gateway)})`}</Text>
          <Badge status={badgeColor}>{baseHelper.ucFirst(status)}</Badge>
        </InlineStack>
      </InlineStack>
      <Text variant="bodySm" as="p">
        {`${cms("label.vendor")}: `}
        <Link onClick={() => navigate(`${links.vendor.link}${vendorId}`)}>{vendor}</Link>
      </Text>
      {errorMessage ? <Text variant="bodySm" as="p">{`${cms("label.reason")}: ${errorMessage}`}</Text> : ""}
      <Text variant="bodySm" as="p">{`${cms("label.dueDate")}: ${baseHelper.formatDate(dueDate)}`}</Text>
      <Text variant="bodySm" as="p">
        <Text as="span" tone="subdued">{`${cms("label.createdOn")}: ${baseHelper.formatDate(createdAt)} `}</Text>
      </Text>
    </ResourceList.Item>
  );
}

List.propTypes = listProp.type;
export default List;
